import EstateComplexIntercomContainer from "@/domains/estate/containers/EstateComplexIntercomContainer";
import EstateElevatorContainer from "@/domains/estate/containers/EstateElevatorContainer";
import EstateIntercomContainer from "@/domains/estate/containers/EstateIntercomContainer";
import EstateFridgeContainer from "@/domains/estate/containers/fridge/EstateFridgeContainer";
import EstateModalsContainer from "@/domains/estate/containers/modals/EstateModalsContainer";
import EstateDesignVariantPresentationContainer from "@/domains/estate/containers/tablet/tabs/design/EstateDesignVariantPresentationContainer";

export default function EstateContainer() {
  return (
    <>
      <EstateDesignVariantPresentationContainer />
      <EstateModalsContainer />
      <EstateElevatorContainer />
      <EstateIntercomContainer />
      <EstateComplexIntercomContainer />
      <EstateFridgeContainer />
    </>
  );
}
